module.exports = "data:image/gif;base64,R0lGODlhtAABAIABAKavvgAAACH5BAEAAAEALAAAAAC0AAEAAAIWjIGJxqzazlux2ovlzND2rAHgSIZWAQA7"